<template>
  <div id="Drivers">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex w-100 justify-content-between align-items-center">
          <h1 class="labelBold">
            {{ this.$t(`mobilityOnDemand.driversMobility.title`) }}
          </h1>
      </div>
      <div class="col-md-12">
        <v-server-table
          :columns="table_options.columns"
          :options="table_options.options"
          ref="driversTable"
        >
          <template #driver_status="props">{{ translateStatus(props.row.driver_status) }}</template> 
          
         
          <template #actions="props">
            <div class="actionsDrivers">
              <!-- Edit -->
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Driver Edit',
                  params: {
                    id: props.row.id,
                    controlNumber: props.row.control_number,
                    edit: true
                  }
                }"
              >
                <i class="far fa-edit"></i>
              </router-link>

             
            </div>
          </template>

             <div slot="filter__driver_status">
              <select class="form-control" name="driver_status" id ="driver_status" v-model="selected"  @change="filterStatus(selected)">
              <option v-for="option in options"
              v-bind:key="option.id"
              v-bind:value="option.id">
              {{option.name }}
              </option>
            </select>
            </div>

        </v-server-table>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/MobilityOnDemand.js";
import store from '@/vuex/store';
const api = new API_SERVICE();

export default {

  components: {
    store
  },
  data() {
    return {
     selected:""
    };
  },
  methods: {
   

      translateStatus (status) {

      if (status == true){
      status = this.$t("mobilityOnDemand.driversMobility.active")
      }
      else if(status == false){
       status = this.$t("mobilityOnDemand.driversMobility.inactive")
      }
       else if(status == null){
       status =  this.$t("mobilityOnDemand.driversMobility.noDriver")
       }
       else {
        status
      }
      return status
    },

    filterStatus: function( $event)
    {
      
      if($event != "choose"){
      let status = ""
      if ($event == true){
    	status = "is true"
	    }
      else if($event == false){
    	status = "is false"
	    }
      else if($event == null){
    	status = "is null"
	    }
      this.driversTable.setFilter({"driver_status":status});
      }
      else{
         
         this.driversTable.setFilter({"driver_status":""});
     
      }
    },
  },
  computed: {

       options(){
        return[
      {id:"choose",name: this.$t('mobilityOnDemand.choose')} ,
      {id:true,name: this.$t("mobilityOnDemand.driversMobility.active")} ,
      {id:false,name: this.$t("mobilityOnDemand.driversMobility.inactive")},
      {id:null,name: this.$t("mobilityOnDemand.driversMobility.noDriver")}
        ]},

 
    driversTable: function() {
      return this.$refs.driversTable;
    },
    table_columns: function() {
      return [
            "control_number",
            "email",
            "name",
            "last_name",
            "mothers_last_name" ,
            "gender",
            "birthdate",
            "working_shift",
            "daily_working_shift",
            "boss_control_number",
            "driver_status",
            "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `mobilityOnDemand.driversMobility.tableDrivers.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
           columnsClasses: {
            actions: "actions-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("mobilityOnDemand.driversMobility.tableDrivers.column_toggler")
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page ;
            queries.limit = data.limit;
            queries.query = data.query;
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {

              const resp = await api.getDriversList(data);
              this.$store.commit("global/SET_LOADING", false);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                 msg: `${error}`,
                 show: true,
                 type: "error"
               });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.data,
              count: response.total
            };
          }
        }
      };
    }
  }
};
</script>

<style lang="scss">

#Drivers {
  background-color: $white;
  padding: 2rem 4rem;
}
.btn-download {
  padding: 0.5rem 2rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.actionsDrivers {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actionsDrivers > *, button {
  cursor: pointer;
}
.actionsDrivers > .edit-btn {
  color: #000000;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: #000000;
  }
}



  .VueTables__table .actions-column {
    position: sticky;
    right: 0;
    text-align: center;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #f2f2f2;
      top: 0;
      right: 0;
      border-collapse: collapse;
    }
  }
  .VueTables__table .actions-column > * {
    position: relative;
    z-index: 1;
  }
  .table-striped tbody tr:nth-of-type(odd) > .actions-column {
    &:after {
      background-color: #e6e6e6;
    }
  }
  .VueTables__table .id-column {
    max-width: 100px;
  }
  [class$="filter-wrapper"] {
    min-width: 80px;
    max-width: fit-content;
  }
</style>

<style>

  .VueTables thead  { 
            position: sticky;
            top: 0;
            z-index: 10;
            background-color: #ffffff;
           
        }
    
        .table-responsive { 
            height:600px;
            overflow:scroll;
        }

.VueTables__driver_status-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
 }
#driver_status{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}

.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown {
  float: left !important;
}
.VueTables__columns-dropdown > button {
  color: #000 !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
}
.VueTables .dropdown .dropdown-menu a {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.VueTables .dropdown .dropdown-menu a > input {
  margin-right: 0.5rem;
}


</style>
